export default __webpack_public_path__ + "d4750655951e34aefe788a6d26de6fb5.png";